import * as React from 'react';
import { AppBar, Toolbar, Typography } from '@mui/material';

import { gray100, white } from '../../constants/colors';
import { spHeaderHeight } from '../../constants/location';
import { titleHeader } from '../../constants/basic';

type Props = {
  pcIsNone?: boolean;
};

const Header = React.forwardRef((props: Props, _ref: React.Ref<unknown>): React.ReactElement => {
  const { pcIsNone } = props;

  return (
    <AppBar
      sx={{
        backgroundColor: gray100,
        boxShadow: 'none',
        '@media screen and (max-width: 600px)': {
          height: spHeaderHeight,
        },
        '@media screen and (min-width: 960px)': {
          display: pcIsNone ? 'none' : 'auto',
        },
      }}
    >
      <Toolbar
        sx={{
          '@media screen and (max-width: 600px)': {
            minHeight: spHeaderHeight,
          },
        }}
      >
        <Typography
          sx={{
            Color: white,
            fontSize: '24px',
            fontWeight: '700',
          }}
        >
          {titleHeader}
        </Typography>
      </Toolbar>
    </AppBar>
  );
});

Header.displayName = 'Header';
export default Header;
